import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button } from '@dsny/dsny-component-library'
import { Actions, Feedback, Message } from './PlaylistDownloadFeedback.styles'

const PlaylistDownloadFeedback = ({
  failure = null,
  isPreparing = false,
  onDismiss,
  onRetry
}) => {
  const { t } = useTranslation()

  return (
    <>
      {isPreparing && (
        <Feedback aria-live="polite" role="status">
          <Message>{t('playlist.preparing-download')}</Message>
        </Feedback>
      )}
      {failure && (
        <Feedback role="alert">
          <Message $isError={failure.retryable}>
            {t(failure.messageKey)}
          </Message>
          <Actions>
            {failure.retryable && onRetry && (
              <Button
                disabled={isPreparing}
                mode="dark"
                setting="player"
                type="button"
                variant="secondary"
                onClick={onRetry}>
                {t('playlist.retry')}
              </Button>
            )}
            <Button
              mode="dark"
              setting="player"
              type="button"
              variant="tertiary"
              onClick={onDismiss}>
              {t('general.ok')}
            </Button>
          </Actions>
        </Feedback>
      )}
    </>
  )
}

PlaylistDownloadFeedback.propTypes = {
  failure: PropTypes.shape({
    messageKey: PropTypes.string.isRequired,
    retryable: PropTypes.bool.isRequired
  }),
  isPreparing: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onRetry: PropTypes.func
}

export default PlaylistDownloadFeedback
